import { useLang } from "@/i18n/LangContext";
import { ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";

const LANGUAGES = [
  { code: "fr", label: "FR", full: "Fran\u00e7ais" },
  { code: "en", label: "EN", full: "English" },
  { code: "ar", label: "\u0639\u0631", full: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629" },
];

export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div ref={ref} className={`relative ${className}`} data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-3 py-1.5 border border-white/15 text-white/80 hover:text-white hover:border-[#C8A951]/50 transition-all duration-300 text-sm font-body"
        data-testid="language-switcher-btn"
      >
        <span>{current.label}</span>
        <ChevronDown size={14} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-2 bg-[#1A1A1A] border border-white/10 z-50 min-w-[120px] overflow-hidden">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm font-body transition-colors ${
                lang === l.code ? "text-[#C8A951] bg-[#C8A951]/10" : "text-white/70 hover:text-white hover:bg-white/5"
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="font-medium">{l.label}</span>
              <span className="text-xs ml-2 text-[#A1A1AA]">{l.full}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
